import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage, useIntl } from 'react-intl';
import { Typography } from '@mui/material';
const COMPONENTS = {
    Typography: Typography,
    default: 'span',
};
export const Translation = props => {
    const { component, componentProps, id = '', defaultMessage, className, isAllTextShown, } = props;
    const intl = useIntl();
    const slicedMessage = intl.formatMessage({ id }).slice(0, 65);
    const Component = COMPONENTS[component] || COMPONENTS.default;
    return (_jsx(Component, { ...(!!componentProps && { ...componentProps }), "data-test": props['data-test'], "data-translationkey": id, className: className, children: isAllTextShown
            ? slicedMessage
            : (intl.formatMessage({ id }) !== id || defaultMessage) && (_jsx(FormattedMessage, { ...props }, void 0)) }, void 0));
};
//# sourceMappingURL=Translation.js.map